export function parseTrayResponseByKey(key: string, payload: any): any[] {
  if (!payload?.viewer?.[key]?.edges) {
    return [];
  }
  return payload.viewer[key].edges.map((edge: any) => {
    return { ...edge.node };
  });
}
